module.exports = __webpack_public_path__ + "static/media/memberEmail.svg";